export default __webpack_public_path__ + "static/media/herobg.43d8b322.jpg";